/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Board_AriaInputs */

const en_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanban Board`)
};

const fr_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau kanban`)
};

const de_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanban-Board`)
};

const it_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bacheca Kanban`)
};

const ru_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Канбан-доска`)
};

const es_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tablero Kanban`)
};

const zh_cn2_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看板`)
};

const ja_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンバンボード`)
};

const hi_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कानबन बोर्ड`)
};

const pt_pt2_explorer_kanban_board_aria = /** @type {(inputs: Explorer_Kanban_Board_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro Kanban`)
};

/**
* | output |
* | --- |
* | "Kanban Board" |
*
* @param {Explorer_Kanban_Board_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_board_aria = /** @type {((inputs?: Explorer_Kanban_Board_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Board_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_board_aria(inputs)
	if (locale === "de") return de_explorer_kanban_board_aria(inputs)
	if (locale === "it") return it_explorer_kanban_board_aria(inputs)
	if (locale === "ru") return ru_explorer_kanban_board_aria(inputs)
	if (locale === "es") return es_explorer_kanban_board_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_board_aria(inputs)
	if (locale === "ja") return ja_explorer_kanban_board_aria(inputs)
	if (locale === "hi") return hi_explorer_kanban_board_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_board_aria(inputs)
	return en_explorer_kanban_board_aria(inputs)
});